import {Image} from '@shopify/hydrogen';
import {Product} from '@shopify/hydrogen/storefront-api-types';
import clsx from 'clsx';
import Carousel from 'nuka-carousel';

import type {PartialDeep} from 'type-fest';

export function Gallery({product}: {product: PartialDeep<Product>}) {
  const media = product?.media?.nodes;
  const images = media?.filter(
    (m) => m?.alt !== 'before' && m?.alt !== 'after',
  );

  if (!media?.length) {
    return <></>;
  }

  return (
    <div className="" tabIndex={-1}>
      <Carousel
        autoplay={false}
        wrapAround={false}
        renderCenterLeftControls={null}
        renderCenterRightControls={null}
        renderBottomCenterControls={({
          pagingDotsIndices,
          currentSlide,
          goToSlide,
        }) => (
          <div className="mb-4 flex gap-2">
            {pagingDotsIndices.map((dot, index) => (
              <button
                key={dot}
                onClick={() => goToSlide(index)}
                className={clsx(
                  'h-2 rounded-full bg-white duration-300',
                  currentSlide == dot ? 'w-6' : 'w-2',
                )}
              ></button>
            ))}
          </div>
        )}
        disableEdgeSwiping={images && images.length <= 1 ? true : false}
      >
        {images?.map((d) => (
          <Image
            key={d?.id}
            src={d?.previewImage?.url ?? ''}
            alt={d?.previewImage?.altText ?? ''}
            className="h-full w-full object-cover object-center"
            width={d?.previewImage?.width ?? 600}
            height={d?.previewImage?.height ?? 600}
          />
        ))}
      </Carousel>
    </div>
  );
}
